import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { Flex } from 'foundations-components/components/Flex';
import { trackPageView } from '../utils/usageTracker';
import { SubscriptionsCard } from '../components/SubscriptionsCard';
import { InvoicesCard } from '../components/InvoicesCard';
import useBillingAndPaymentsData from '../hooks/useBillingAndPaymentsData';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Billing() {
  const {
    data: {
      subscriptions,
      invoices
    },
    invoices: invoicesPagination,
    subscriptions: subscriptionsPagination
  } = useBillingAndPaymentsData();
  const hasNoInvoices = (invoices === null || invoices === void 0 ? void 0 : invoices.length) === 0;
  const hasNoSubscriptions = (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) === 0;
  useEffect(() => {
    trackPageView('billing');
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "BILLING_LOAD",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "300",
      children: [!hasNoSubscriptions && /*#__PURE__*/_jsx(SubscriptionsCard, {
        subscriptions: subscriptions,
        pagination: subscriptionsPagination
      }), !hasNoInvoices && /*#__PURE__*/_jsx(InvoicesCard, {
        invoices: invoices,
        pagination: invoicesPagination
      })]
    })
  });
}